export enum CatalogueResourceSlug {
  Tools = 'tools',
  ToolUseCases = 'tool-use-cases',
  Metrics = 'metrics',
  MetricUseCases = 'metric-use-cases',
}
